import React, { useState } from 'react';
import { useAuth, FLOW } from '../AuthProvider';
import AuthShell, { Label, Input, PrimaryButton, ErrorBanner } from '../AuthShell';

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      // AuthProvider sets `flow`; AuthRouter takes us to the right page.
    } catch (err) {
      setError(
        err?.detail === 'invalid_credentials' ? 'Incorrect email or password.' :
        err?.detail === 'account_disabled'    ? 'Account is disabled. Contact an administrator.' :
        err?.message || 'Login failed.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="ContinuumCX" subtitle="Sign in to your account">
      <form onSubmit={onSubmit} className="space-y-4">
        <ErrorBanner>{error}</ErrorBanner>
        <div>
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@continuumgbl.com"
          />
        </div>
        <div>
          <Label htmlFor="password">Password</Label>
          <Input
            id="password"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <PrimaryButton type="submit" loading={loading}>Sign in</PrimaryButton>
      </form>
    </AuthShell>
  );
}
